/* eslint-disable no-undef -- This file is only needed in the browser which defines "window" */
import $ from "jquery";
import numbro from "numbro";

window.$ = $;
window.jQuery = $;
window.numbro = numbro;
/* eslint-enable no-undef */
